import { Modal } from '@clientbase/clientbase-library'

import { Record as CustomerChargeRecord } from 'components/Modal/ModalInvoice/components/Table/Table'
import ModalInvoiceContent from 'components/Modal/ModalInvoice/ModalInvoiceContent'

interface ModalEmitNfseForChargeProps {
  open: boolean
  /** Fecha o modal, emitindo ou não a nota. */
  onClose: () => void
  /** Só roda quando a nota foi enviada para emissão com sucesso. */
  onEmitted?: () => void
  /** Cobrança que já entra selecionada para vínculo com a nota. */
  charge: CustomerChargeRecord
  /** Valor inicial da nota; sem ele o campo começa vazio. */
  initialAmount?: string
}

/**
 * Atalho "Emitir Nota Fiscal" de uma cobrança: abre a emissão de nota avulsa com
 * o cliente, o valor e o vínculo com a cobrança já preenchidos.
 */
const ModalEmitNfseForCharge = ({
  open,
  onClose,
  onEmitted,
  charge,
  initialAmount
}: ModalEmitNfseForChargeProps) => (
  <Modal
    open={open}
    handleClose={onClose}
    disablePortal={false}
    width="100%"
    maxWidth="85vw"
    maxHeight="90vh"
    height="100%"
  >
    <ModalInvoiceContent
      handleToggle={onClose}
      handleReloadTable={onEmitted}
      customer={{
        label: charge.customer?.name ?? '',
        uuid: charge.customer?.uuid ?? ''
      }}
      initialAmount={initialAmount}
      preselectedCharge={charge}
    />
  </Modal>
)

export default ModalEmitNfseForCharge
